mutation CreateSalesDocument($input: SalesDocumentCreateInput!) {
    salesDocumentCreate(input: $input) {
        salesDocument {
            id
            modalUrl
        }
    }
}
